import styled from "styled-components/macro";
import { RestorableTiptapField } from "../../TiptapField";
import { SudoButton } from "../../../sudokit/components/SudoButton";

const FieldLoadingContainer = styled.div`
  overflow: hidden;
  border-radius: 6px;
  .progress-bar {
    height: 100%;
    width: 100%;
  }

  .gradient-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
    flex-grow: 1;
    box-sizing: border-box;

    background-clip: padding-box; /* !importanté */
    border: solid 1px transparent;
    border-radius: 5px;
  }

  .content-container {
    z-index: 2;
    border-radius: 5px;
    width: 100%;
    background-color: var(--menu-color);
  }

  .gradient-box:before {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    height: 100vw;
    /* margin: -35px;  */
    border-radius: inherit; /* !importanté */
    background: conic-gradient(var(--primary-cta), var(--menu-color), var(--primary-cta));
    -webkit-animation: rotate-border 5s linear infinite;
    -moz-animation: rotate-border 5s linear infinite;
    -o-animation: rotate-border 5s linear infinite;
    animation: rotate-border 5s linear infinite;
    transform: translate(-50%, -50%) rotate(0deg);
  }

  @keyframes rotate-border {
    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  .fullWidth {
    width: 100%;
    flex-grow: 1;
    z-index: 2;

    > div {
      background: var(--menu-color) !important;
      color: var(--grey-0);
    }
  }
`;

function FieldLoading({ content, loadingText, userId, projectId }) {
  return (
    <FieldLoadingContainer>
      <div className="gradient-box">
        <div className="content-container">
          <RestorableTiptapField
            value={content}
            readOnly
            className="fullWidth"
            userId={userId}
            projectId={projectId}
          />
          {loadingText && (
            <SudoButton
              state="loading"
              variant="tertiary"
              loadingPercentage={90}
              loadingTransitionDuration={5}
              className="mb-2 ml-2"
            >
              {loadingText}
            </SudoButton>
          )}
        </div>
      </div>
    </FieldLoadingContainer>
  );
}

export default FieldLoading;
